import { render } from "./LabWorkSheet.vue?vue&type=template&id=1843c324"
import script from "./LabWorkSheet.vue?vue&type=script&lang=js"
export * from "./LabWorkSheet.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\mlab\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__